
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#0B0B0A","fill-rule":"evenodd","stroke":"#8C99AD"}},[_c('path',{attrs:{"d":"M16.333 9.5H1.667C1.299 9.5 1 9.279 1 8.999s.299-.499.667-.499h14.666c.368 0 .667.219.667.499s-.299.501-.667.501"}}),_c('path',{attrs:{"d":"M9 17c-.276 0-.5-.293-.5-.665V1.668C8.5 1.295 8.724 1 9 1s.5.295.5.668v14.667c0 .372-.224.665-.5.665"}})])])
          )
        }
      }
    